import { navLinks, siteInfo } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-file-text-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              {siteInfo.slogan}。我们把《黑料短剧》的分集介绍、故事梗概与角色关系统一整理，方便你在追剧时随时对上细节。
            </p>
            <p className="mt-4 text-sm text-background-300">
              <span className="mr-1">联系邮箱：</span>
              <a
                href={`mailto:${siteInfo.email}`}
                className="text-primary-200 underline-offset-4 hover:underline cursor-pointer"
              >
                {siteInfo.email}
              </a>
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#top" className="cursor-pointer">站内导航</a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#overview" className="cursor-pointer">内容说明</a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li>本站仅做剧情整理与解析</li>
              <li>不提供影视播放服务</li>
              <li>更新节奏：{siteInfo.updateText}</li>
              <li>内容随剧集同步维护</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name}. 内容仅供追剧参考。</p>
          <p>本站为独立剧情整理站点，与剧集出品方无隶属关系。</p>
        </div>
      </div>
    </footer>
  );
}